// Authentication Configuration
// Uses Supabase Auth with database-backed role assignment
// 
// IMPORTANT: All roles are stored in the `user_roles` table in Supabase.
// No hardcoded email lists. See docs/AUTH_SYSTEM.md for admin setup.

export const AUTH_CONFIG = {
  // Authentication settings
  AUTH_ENABLED: true,
  DEFAULT_ROLE: 'viewer' as const,
  
  // Session timeout (in milliseconds) - 24 hours
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000,
  
  // Local storage keys
  STORAGE_KEYS: {
    USER_ROLE: 'marlo-user-role',
    AUTH_TOKEN: 'marlo-auth-token',
    LAST_ACTIVITY: 'marlo-last-activity'
  }
} as const;

// Section editing permissions by role
// All section keys use camelCase to match snapshot keys
export const SECTION_PERMISSIONS = {
  admin: ['updates', 'notes', 'spend', 'promoCodes', 'liveAssets', 'funnel', 'campaignSpend', 'adminFeeTracker', 'bubbleSpendMatrix', 'creators', 'recommendedCreators'], // Admin can edit all sections
  viewer: ['promoCodes'] // Viewer can only edit promo codes
} as const;

// Helper function to check if a user can edit a specific section
export const canEditSection = (role: 'admin' | 'viewer', sectionKey: string): boolean => {
  const allowedSections = SECTION_PERMISSIONS[role] || [];
  // Type assertion needed because readonly array type is narrower than string
  return (allowedSections as readonly string[]).includes(sectionKey);
};

// Configuration: Allow admins to edit past weeks (set to false to protect historical data)
export const ALLOW_PAST_WEEK_EDITS = (import.meta.env.VITE_ALLOW_PAST_WEEK_EDITS ?? 'false') === 'true'; 